module.exports = __webpack_public_path__ + "img/ChurchwardMarianna-Regular.c7da77ef.svg";